import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

export function useInfoStyles() {
  const { spacing } = useTheme();

  const cardStyles = useMemo(
    () => mergeStyleSets({
      root: {
        margin: spacing.s2,
        padding: spacing.m,
        width: `32%`,
        float: `left`,
        "&:nth-child(2n)": {
          float: `right`
        }
      }
    }),
    [spacing]
  );

  const gridStyles = useMemo(
    () => mergeStyleSets({
      root: {
        height: `150px`
      }
    }),
    []
  );

  return { gridStyles, cardStyles };
}
